import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TextInput from '../../../general-components/text-input';
import { GreenroomState } from '../../../../stores/types/types';
import { getTrimSaveCopyName } from '../../../../utils/utils';

interface Props {
	cancel: Function;
	confirm: Function;
	open: boolean;
	name: string;
	originalId: number;
}

export default function RenameDialog(props: Props) {
	const media = useSelector((state: GreenroomState) => state.MediaReducer.media);
	const [newName, setNewName] = useState<string>(getTrimSaveCopyName(
		props.originalId,
		media,
	));

	useEffect(() => {
		setNewName(getTrimSaveCopyName(
			props.originalId,
			media,
		));
	}, [props.open]);

	return (
		<div
			style={{ display: props.open ? 'flex' : 'none' }}
			className='trim-rename-dialog-wrap'
		>
			<div className='trim-rename-dialog'>
				<div className='trd-header'>
						Give your copy a name
				</div>
				<TextInput
					placeholder={'Title*'}
					onChange={(e) => { setNewName(e.target.value); }}
					value={newName}
					customClassNameProp={'trim-rename-input'}
				/>
				<div className='justify-content-end width-full'>
					<button
						onClick={() => props.cancel()}
						className="padding-button-medium-wide background-lighter corner-round-massive margin-right-medium button-background-shading"
					>
						<span className="text-light-gray">Cancel</span>
					</button>
					<button
						onClick={() => props.confirm(newName)}
						disabled={newName === ''}
						className="padding-button-medium-wide background-green corner-round-massive button-background-shading"
					>
						<span className="text-dark">Save Copy</span>
					</button>
				</div>
			</div>
		</div>
	);
}
